import { inject, Injectable } from '@angular/core';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { ErrorOverlayService } from './error-overlay.service';

/**
 * Replaces ToastrService app-wide (see app.config.ts) so every existing
 * toastr.error(...) call site gets the dimming backdrop for free.
 */
@Injectable({ providedIn: 'root' })
export class ErrorOverlayToastrService extends ToastrService {
  private readonly _overlay = inject(ErrorOverlayService);

  override error<ConfigPayload = unknown>(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig<ConfigPayload>>,
  ): ActiveToast<unknown> {
    const toast = super.error(message, title, override);
    this._overlay.show(() => this.clear(toast.toastId));
    toast.onHidden.pipe(take(1)).subscribe(() => this._overlay.close());
    return toast;
  }
}
